<template>
  <div v-if="amReady">
    <el-row class="mb-3">
      <div class="m-0 p-0 mb-5 border-bottom" v-if="formHeader">
        <h5>{{ this.getFormTitle }}</h5>
      </div>
      <div class="mb-2" v-else></div>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :field_span="19"
            :editable="!editMode"
            :label_span="24"
            :options="usersDropDownList"
            :translateLabels="false"
            field_mark="required"
            label="username"
            name="user_id"
            rules="required"></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :editable="editable"
            :field_span="19"
            :label_span="24"
            :options="fusionServerList"
            :translateLabels="false"
            field_mark="required"
            label="fusion_server"
            name="fusion_server_id"
            rules="required"></dg-select-field>
      </el-col>
    </el-row>
    <el-row class="mb-3">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="19"
            :label_span="24"
            :translateLabel="false"
            field_mark="required"
            label="Name"
            name="config_name"
            placeholder="VQ Testing"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="19"
            :label_span="24"
            :translateLabel="false"
            field_mark="required"
            label="Outbound Prefix"
            name="outbound_prefix"
            placeholder="111192"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="editable"
            :field_span="19"
            :label_span="24"
            :translateLabel="false"
            field_mark="required"
            label="Destination Data"
            name="destination_data"
            placeholder="920"
            rules=""></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <button @click="addConfigRow(-1)" class="el-button el-button--success mt-4">Add</button>
      </el-col>
    </el-row>

    <h4 class="mb-4">Configs</h4>
    <el-col :class="$langConfig.cssClass" :span="(!editMode)? 24 : 24" v-if="!thereAreFields && !editMode">
      <h6 class="mt-4 ml-4 font-italic text-secondary">Currently there are no fields</h6>
    </el-col>


    <el-row :key="key" class="mb-3" v-for="(config, key) in currentConfigRows">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="false"
            :field_span="19"
            :label_span="24"
            :translateLabel="false"
            :defaultValue="config.config_name"
            field_mark="required"
            label="Name"
            name=""
            placeholder="VQ Testing"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="false"
            :field_span="19"
            :label_span="24"
            :translateLabel="false"
            :defaultValue="config.outbound_prefix"
            field_mark="required"
            label="Outbound Prefix"
            name=""
            placeholder="111192"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-text-field
            :control="control"
            :editable="false"
            :field_span="19"
            :label_span="24"
            :translateLabel="false"
            :defaultValue="config.destination_data"
            field_mark="required"
            label="Destination Data"
            name=""
            placeholder="920"
            rules="required"></dg-text-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <button @click="removeConfigRow(key)" class="el-button mt-2 el-button--danger p-2 el-button--small">X</button>
      </el-col>
    </el-row>
    <el-row class="mb-3">
      <el-col :span="24" class="mt-2 border-top">
        <el-col :class="$langConfig.cssClass" :span="12" class="mt-4">
          <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                          v-show="!this.validData"></dg-label-field>
        </el-col>
        <el-col :span="12" class="pt-3 text-right">
          <dg-confirm-button
              :loading="requestOn"
              :onConfirm="removeAction"
              :translate="false"
              class="mr-2"
              confirmButtonType="danger"
              fieldSize="mini"
              icon="el-icon-delete"
              popIcon="el-icon-delete"
              text="remove"
              title="sure to removing this record ?"
              type="danger"
              v-if="editMode"></dg-confirm-button>

          <dg-confirm-button
              :icon="actionButtonIcon"
              :loading="requestOn"
              :onConfirm="createModule"
              :text="actionButtonLabel"
              :translate="false"
              :type="actionButtonType"
              fieldSize="mini"
              v-if="true"></dg-confirm-button>
        </el-col>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapState, mapActions} from 'vuex'
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import {notify} from '@/system-services/notify.js'

export default {
  mixins: [fieldController],
  props: {
    recordId: {
      required: false,
      default: false
    },
    formHeader: {
      required: false,
      default: false
    },
    formTitle: {
      required: false
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false
    },
    onCreateCallback: {
      required: false
    },
  },
  data() {
    return {
      control: this,
      amReady: true,
      requestOn: false,
      thereAreFields: false,
      currentConfigRows: {},
      editable: true,
      fusionServerList: [],
      usersDropDownList: [],
      profilesOptionsList: $store.state['user-state'].usersProfiles,
      module: {
        ...module
      }
    }
  },
  computed: {
    ...mapState('user-state', ['usersList']),
    ...mapState('voip-testing-panel-setting-state', ['fusionList']),
    ...mapState('ajaxManager', ['loadingRequests']),
    getFormTitle: function () {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'create';
      } else {
        return 'save'
      }
    },
    actionButtonIcon: function () {
      if (!this.editMode) {
        return 'el-icon-plus';
      } else {
        return 'el-icon-check'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger btn-small';
      } else {
        if (!this.editMode) {
          return 'primary app-bg-primary';
        } else {
          return 'primary'
        }
      }
    }
  },
  beforeMount() {
    this.usersDropDownList = this.usersList
    if (this.usersDropDownList.length < 1) {
      this.getUsersDropDownList({valueKey: 'id'}).then((r) => {
        this.setStateUsers({key: 'usersList', value: r})
        this.usersDropDownList = r
      })
    }

    this.fusionServerList = this.fusionList
    if (this.fusionServerList.length < 1) {
      this.getFusionsDropDownList({valueKey: 'id'}).then((r) => {
        this.setState({key: 'fusionList', value: r})
        this.fusionServerList = r
      })
    }

    if (this.editMode) {
      let configs = JSON.parse(this.dataToBind.test_types)
      for (let f in configs) {
        this.addConfigRow(configs[f])
      }
    }
  },
  methods: {
    ...mapActions('user-state', {setStateUsers: 'setState'}),
    ...mapActions('user-api', {getUsersDropDownList: 'getUsersDropDownList'}),
    ...mapActions('voip-testing-panel-setting-state', {setState: 'setState'}),
    ...mapActions('voip-fusion-server-api', {getFusionsDropDownList: 'getDropDownList'}),
    removeConfigRow(key) {
      delete this.currentConfigRows[key]
      this.$forceUpdate()
    },
    addConfigRow(data = null) {

      let error = false;
      let outbound_prefix = null
      let destination_data = null
      let config_name = null

      if (data === -1) {
        outbound_prefix = this.dataModel.outbound_prefix
        destination_data = this.dataModel.destination_data
        config_name = this.dataModel.config_name
      } else {
        outbound_prefix = data.outbound_prefix
        destination_data = data.destination_data
        config_name = data.config_name
      }


      if (!config_name || config_name === '') {
        this.fields['config_name'].field.validateMessage = 'this field is required'
        error = true
      }

      if (!destination_data || destination_data === '') {
        this.fields['destination_data'].field.validateMessage = 'this field is required'
        error = true
      }

      if (!outbound_prefix || outbound_prefix === '') {
        this.fields['outbound_prefix'].field.validateMessage = 'this field is required'
        error = true
      }

      if (error) return error

      this.thereAreFields = true
      this.currentConfigRows[outbound_prefix + '-' + destination_data] = {
        outbound_prefix: outbound_prefix,
        destination_data: destination_data,
        config_name: config_name
      }

      if (data === -1) {
        delete this.dataModel.outbound_prefix
        this.fields['outbound_prefix'].field.field_value = ''
        this.fields['outbound_prefix'].field.validateMessage = ''
        this.fields['outbound_prefix'].field.updateValue()

        delete this.dataModel.destination_data
        this.fields['destination_data'].field.field_value = ''
        this.fields['destination_data'].field.validateMessage = ''
        this.fields['destination_data'].field.updateValue()

        delete this.dataModel.config_name
        this.fields['config_name'].field.field_value = ''
        this.fields['config_name'].field.validateMessage = ''
        this.fields['config_name'].field.updateValue()
        this.$forceUpdate()
      }
    },
    cancelEditable() {
      let context = this
      this.amReady = false
      this.editable = false
      Vue.nextTick(() => {
        context.amReady = true
      })
    },
    changeEditable() {
      this.editable = !this.editable
    },
    removeAction(params) {
      let cxt = this
      this.requestOn = true
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: this.recordId}).then(response => {
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
          message: '',
          position: 'topRight',
          close: false,
          timeout: 1900,
          animateInside: true,
        });
        cxt.amReady = false
      })
    },
    createModule() {
      this.validateFields().then(result => {
        if (!result) return

        let keys = Object.keys(this.currentConfigRows)
        if (!keys.length) {
          iziToast.warning({
            title: '',
            message: 'Entity Should Have One Config as Minimum',
            position: 'center',
            close: false,
            timeout: 1900,
            animateInside: true
          });
          return
        }

        let context = this;
        this.requestOn = true
        delete this.dataModel.destination_data
        delete this.dataModel.outbound_prefix
        delete this.dataModel.config_name

        this.dataModel.test_types = this.currentConfigRows

        let data = {data: this.dataModel};
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }

        let api = (this.editMode) ? 'update' : 'create';
        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
          if (!context.editMode) {
            this.amReady = false
          }

          notify({
            type: 'success',
            title: this.$ml.get('successfully'),
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true,
          });

          Vue.nextTick(() => {
            context.amReady = true
            context.requestOn = false
            /*if (context.editable) {
              context.editable = false
            }*/
            if (context.editMode) {
              if (context.onEditCallback) {
                context.onEditCallback(response.data)
              }
            } else {
              if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }
            }
          })
          // this.$router.push({ name: this.module.stateName + '-module-list', params: {}}).then( response => {})
        }).catch(error => {
          console.log('catch error', error)
          this.setfieldsErrorMessage({
            fieldsErrors: error.response.data
          });
        }).finally(() => {
          this.requestOn = false
        })

      })
    }
  }
}
</script>
